import { Box, Typography, Checkbox as CustomCheckbox } from "@material-ui/core";

export default function Checkbox({ label, checked, onChange, disabled }) {
  return (
    <Box display="flex" flexDirection="row" alignItems="center" gap={2} mt={1}>
      <CustomCheckbox
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <Typography variant="body1" style={{ margin: 0 }}>
        {label}
      </Typography>
    </Box>
  );
}
